<template>
  <j-modal
    title="消息推送"
    :width="600"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    @ok="handleOk"
    okText="发送"
    @cancel="handleCancel"
  >
    <div>{{ content }}</div>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import { getAction } from '@api/manage'

export default {
  name: 'EmailDetailModal',
  components: {
    JDate,
  },
  props: {},
  data() {
    return {
      visible: false,
      detailList: [],
      content: '',
      studentInfo: {},
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data) {
      console.log('消息推送--', data)
      this.visible = true
      this.content =
        '尊敬的' +
        data.name +
        '同学家长，我们期待与您一起更多关注您孩子的在校情况，点击本消息可访问您孩子的“爱心小叮当“情绪空间。'
      this.studentInfo = data
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    async handleOk() {
      getAction('/ddUser/getParentIds', {
        studentId: this.studentInfo.studentId,
        urlDing: 'pagesA/pages/Home/h-rector/detail?role=4&corpId=',
        text: '# 爱心小叮当  \\n  ' + this.content,
      }).then((res) => {
        if (res.success) {
          this.$message.success('消息推送成功')
        }
      })
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  // justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
</style>
